import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChartTypes } from '@mode/shared/contract-common';
import { TableFormatSetting, datePatternOptions } from '@mode/shared/util-js';
import * as TextFormattingHelpers from '../text-formatting-helpers';

export const BASE_FORMAT: ChartTypes.TextFormat.DateType = {
  ...TextFormattingHelpers.getBaseFormatByShortcutType(ChartTypes.FormatShortcutType.DateAndTime),
};

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule],
  selector: 'mode-date-format-pane',
  templateUrl: './date-format-pane.component.html',
  styleUrls: ['./date-format-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFormatPaneComponent implements OnChanges {
  @Input({ required: true }) format!: ChartTypes.TextFormat.DateType;
  @Output() formatChange = new EventEmitter<ChartTypes.TextFormat.DateType>();

  dateFormatUiOptions: TableFormatSetting[] = datePatternOptions;

  ngOnChanges(): void {
    this.format = {
      ...BASE_FORMAT,
      ...this.format,
    };
  }

  apply(props: Partial<ChartTypes.TextFormat.DateType>) {
    this.format = { ...this.format, ...props };
    this.formatChange.emit({
      ...this.format,
    });
  }

  optionSelected(selected: string) {
    this.apply({
      dateFormat: selected,
    });
  }
}
